import * as yup from 'yup'

export const schema = yup
   .object({
      tipo: yup
         .mixed<'SERVICO' | 'TAXA'>()
         .oneOf(['SERVICO', 'TAXA'], 'Tipo de Nota de Débito inválido')
         .required('Tipo de Nota de Débito é um campo obrigatório'),

      periodo: yup
         .string()
         .required('Período é um campo obrigatório'),

      detran: yup
         .string()
         .nullable(),

      dataEmissao: yup
         .string()
         .required('Data de emissão é um campo obrigatório'),

      vencimento: yup
         .string()
         .required('Data de vencimento é um campo obrigatório')
         .test(
            'vencimento-valido',
            'O vencimento não pode ser anterior à data de emissão',
            function (value) {
               const { dataEmissao } = this.parent

               if (!value || !dataEmissao) {
                  return true
               }

               return value >= dataEmissao
            }
         ),

      quantidade: yup
         .number()
         .typeError('Quantidade é um campo obrigatório')
         .integer('Quantidade deve ser um número inteiro')
         .min(1, 'Quantidade deve ser maior que zero')
         .required('Quantidade é um campo obrigatório'),

      descricao: yup
         .string()
         .trim()
         .max(500, 'Descrição deve possuir no máximo 500 caracteres')
         .required('Descrição é um campo obrigatório'),

      tipoGeracao: yup
         .mixed<'CONSOLIDADA' | 'POR_LINHA'>()
         .oneOf(
            ['CONSOLIDADA', 'POR_LINHA'],
            'Tipo de geração inválido'
         )
         .required('Tipo de geração é um campo obrigatório')
   })
   .required()